'use strict';

module.exports = function (response)
{
    if ( response.status !== 200 )
    {
        throw('Geen 200 response');
    }
    return response.json();
};